import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { CaretDown } from "components/icons/CaretDown";
import { useCurrentGroup } from "hooks/useCurrentGroup";
import { useModal } from "hooks/useModal";
import { Merchant } from "types/Models/merchant";
import { stopPropagation } from "utils/stopPropagation";
import { SendCopyToVendor } from "./SendCopyToVendor";
import { useDispatch } from "react-redux";
import { vendorsApi } from "store/apis/vendors";
import { taskMerchantApis } from "store/apis/taskMerchants";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";

export const Form1099Options = ({
  merchant,
  season,
}: {
  merchant: Merchant;
  season: string;
}) => {
  const sendCopy = useModal();
  const dispatch = useDispatch();
  const { uuid: groupId } = useCurrentGroupContext();

  const updateMerchant = () => {
    dispatch(vendorsApi.util.invalidateTags(["VENDORS"]));
    dispatch(taskMerchantApis.util.invalidateTags(["Merchants"]));
  };

  return (
    <div onClick={stopPropagation}>
      <Dropdown.Root>
        <Dropdown.Trigger asChild className="t-group">
          <button className="all:unset">
            <div className="group-data-state-open:t-rotate-180 -t-ml-2">
              <CaretDown className="t-text-text-30" />
            </div>
          </button>
        </Dropdown.Trigger>
        <Dropdown.Portal>
          <Dropdown.Content align="end">
            <Dropdown.Item onSelect={sendCopy.open}>
              Send copy to vendor
            </Dropdown.Item>
          </Dropdown.Content>
        </Dropdown.Portal>
      </Dropdown.Root>
      {sendCopy.isOpen && (
        <SendCopyToVendor
          {...sendCopy}
          groupId={groupId || ""}
          season={season}
          updateMerchant={updateMerchant}
          merchant={merchant}
        />
      )}
    </div>
  );
};
